import React from 'react'

import synkdLogo from '../assets/synkd_logo_small.png';
import clubleaLogo from '../assets/clublea_logo_small.svg';
import { isClubLeaDomain } from '../util'


function Loading(props) {
    const logo = isClubLeaDomain() ? clubleaLogo : synkdLogo;
    return (
        <div className='main-container'>
            <img src={logo} width='50px' className="App-logo rotate" alt="logo" />
        </div>
    );
}

export default Loading